import React from "react";
import ZomentumLogo from "../../Assets/LoadingPage/ZomentumLogo.gif";

const LoadingPage: React.FC = () => {
  return (
    <div className="min-w-full flex items-center justify-center my-auto">
      <img className="h-12 md:h-full md:w-24" src={ZomentumLogo} alt={"logo"} />
    </div>
  );
};

export default LoadingPage;
